import { useTextField, useTranslation } from '@zurich/common/hooks';
import { Typography } from '@zurich/ui/atoms';
import { TextField } from '@zurich/ui/legacy/components';
import { partyNameLiveSchema } from '~/lib/schemas';
import {
  emailFieldSelector,
  emailValidationSelector,
  firstNameSelector,
  firstNameValidationSelector,
  lastNameSelector,
  lastNameValidationSelector,
  postalCodeSelector,
  postalCodeValidationSelector,
} from '~/state';
import { StepLayout } from './StepLayout';

export function ContactInformation() {
  const { t } = useTranslation();

  const firstNameProps = useTextField({
    atom: firstNameSelector,
    validationSelector: firstNameValidationSelector,
    fieldName: 'firstName',
    i18nPrefix: 'vsga:fields.',
    yupSchema: partyNameLiveSchema,
    required: true,
  });

  const lastNameProps = useTextField({
    atom: lastNameSelector,
    validationSelector: lastNameValidationSelector,
    fieldName: 'lastName',
    i18nPrefix: 'vsga:fields.',
    yupSchema: partyNameLiveSchema,
    required: true,
  });

  const postalCodeProps = useTextField({
    atom: postalCodeSelector,
    validationSelector: postalCodeValidationSelector,
    fieldName: 'postalCode',
    i18nPrefix: 'vsga:fields.',
    required: true,
  });

  const emailProps = useTextField({
    atom: emailFieldSelector,
    validationSelector: emailValidationSelector,
    fieldName: 'email',
    i18nPrefix: 'vsga:fields.',
    required: true,
  });

  return (
    <StepLayout stepName="contact">
      <Typography variant="body1 medium" color="darkBlue">
        {t('vsga:contactData.subtitle')}
      </Typography>

      <TextField
        {...firstNameProps}
        data-name="first-name"
        label={t('vsga:contactData.first_name')}
        inputProps={{ autoComplete: 'off', 'aria-autocomplete': 'none' }}
        // workaround to prevent the browser from autofilling the field because it makkes it think its a one-time code
        autoComplete="one-time-code"
      />
      <TextField
        {...lastNameProps}
        data-name="last-name"
        label={t('vsga:contactData.last_name')}
        inputProps={{ autoComplete: 'off', 'aria-autocomplete': 'none' }}
        // workaround to prevent the browser from autofilling the field because it makkes it think its a one-time code
        autoComplete="one-time-code"
      />
      <TextField
        {...postalCodeProps}
        data-name="plz"
        label={t('vsga:contactData.postal_code')}
        inputProps={{ autoComplete: 'off', 'aria-autocomplete': 'none' }}
        // workaround to prevent the browser from autofilling the field because it makkes it think its a one-time code
        autoComplete="one-time-code"
      />
      <TextField
        {...emailProps}
        data-name="email"
        label={t('vsga:contactData.email')}
        inputProps={{ autoComplete: 'off', 'aria-autocomplete': 'none' }}
        // workaround to prevent the browser from autofilling the field because it makkes it think its a one-time code
        autoComplete="one-time-code"
      />
    </StepLayout>
  );
}
